module.exports = __webpack_public_path__ + "static/media/bottom-direction-gray.189a271c.svg";